import React from 'react';
import { maxDigitRemove } from '../../../../services/incomingDialedDestination';

function DialedDestinationField({ mask, dialed, onDialedChange, extension, onExtensionChange, hasError }) {
  const inputClassName = `input ${hasError ? 'is-danger' : ''}`;

  return (
    <div>
      <div className="control">
        <label className="radio mr-4">
          <input
            type="radio"
            name="incoming-dialed-destination-mode"
            value="fixed"
            checked={dialed.mode === 'fixed'}
            onChange={() => onDialedChange({ ...dialed, mode: 'fixed' })}
          />
          {' '}Ramal específico
        </label>
        <label className="radio">
          <input
            type="radio"
            name="incoming-dialed-destination-mode"
            value="dialed"
            checked={dialed.mode === 'dialed'}
            onChange={() => onDialedChange({ ...dialed, mode: 'dialed' })}
          />
          {' '}Usar o número discado
        </label>
      </div>

      {dialed.mode === 'dialed' ? (
        <div className="field mt-3">
          <label className="label" htmlFor="incoming-dialed-digit-remove">Dígitos a Remover</label>
          <div className="control">
            <input
              id="incoming-dialed-digit-remove"
              className={inputClassName}
              type="number"
              min="0"
              max={maxDigitRemove(mask)}
              value={dialed.digitRemove}
              onChange={(e) => onDialedChange({ ...dialed, digitRemove: e.target.value })}
            />
          </div>
          <p className="help">Número de dígitos a remover do início do número discado</p>
        </div>
      ) : (
        <div className="control mt-3">
          <input
            className={inputClassName}
            type="text"
            placeholder="Ex: 1000, 1001, 1234"
            value={extension || ''}
            onChange={(e) => onExtensionChange(e.target.value.replace(/\D/g, '').slice(0, 4))}
            maxLength={4}
          />
        </div>
      )}
    </div>
  );
}

export default DialedDestinationField;
